import React from 'react';
import { urlApi } from '../Constants/Global';

import SectionHeader from '../Components/SectionHeader';
import SectionCarousel from '../Components/SectionCarousel';
import SectionContact from '../Components/SectionContact';
import Bg from '../Medias/Photos/photo-bg7.jpg';
import SectionPublication from '../Components/SectionPublication';

const Publication = ({ contents }) => {
  console.log(contents)

  return (
    <>
      <SectionHeader topic='Publications' detail='Explore our latest articles and insights covering key legal developments and expert commentary.' bg={Bg} />
      <SectionPublication />
    </>
  )
}

Publication.defaultProps = {
  contents: {
    lang: 'th',
    content: {
      contents: []
    }
  },
  web_setup: {
    practice_topic: [],
    practice: []
  },
  path: '',
  lang: 'en'
}

export default Publication